import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { Router, RouterModule } from '@angular/router';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';

@Component({
  selector: 'app-inteligencia-dados-home',
  imports: [MenuComponent, RouterModule, ListaFuncionalidadeComponent],
  templateUrl: './inteligencia-dados-home.component.html',
  styleUrl: './inteligencia-dados-home.component.css',
})
export class InteligenciaDadosHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(private router: Router) {
    this.moduloEnum = ModuloEnum.InteligenciaDados;
  }
}
